"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rewards API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateGiveaway201ResponseToJSON = exports.CreateGiveaway201ResponseFromJSONTyped = exports.CreateGiveaway201ResponseFromJSON = exports.instanceOfCreateGiveaway201Response = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the CreateGiveaway201Response interface.
 */
function instanceOfCreateGiveaway201Response(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfCreateGiveaway201Response = instanceOfCreateGiveaway201Response;
function CreateGiveaway201ResponseFromJSON(json) {
    return CreateGiveaway201ResponseFromJSONTyped(json, false);
}
exports.CreateGiveaway201ResponseFromJSON = CreateGiveaway201ResponseFromJSON;
function CreateGiveaway201ResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'data': !(0, runtime_1.exists)(json, 'data') ? undefined : json['data'],
    };
}
exports.CreateGiveaway201ResponseFromJSONTyped = CreateGiveaway201ResponseFromJSONTyped;
function CreateGiveaway201ResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'data': value.data,
    };
}
exports.CreateGiveaway201ResponseToJSON = CreateGiveaway201ResponseToJSON;
